// extracted by mini-css-extract-plugin
export default {"h2":"AdminUsers_h2__MaZ-m","content":"AdminUsers_content__hBpM+","green":"AdminUsers_green__-8Eqz","red":"AdminUsers_red__00Orx","ant-table-row":"AdminUsers_ant-table-row__f-AAu"};